import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const ToysPuzzleOutline = createIcon({
  displayName: 'ToysPuzzleOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M12 3v2.773l-3.94174e-10-2.71955e-08c.00196099.135296-.106128.246564-.241424.248525 -.0440208.000638043-.0874002-.0105974-.125576-.0325249l1.22727e-07 7.00814e-08c-.834502-.476529-1.8973-.186334-2.37383.648168 -.476529.834502-.186334 1.8973.648168 2.37383 .534703.305333 1.19096.305333 1.72566 1.40163e-07l-3.20824e-08 1.84274e-08c.117332-.067393.267082-.0269091.334475.0904234 .0219275.0381762.033163.0815556.032525.125576v2.773h2.773l-6.41897e-09-9.30367e-11c.135296.00196098.246564-.106128.248525-.241424 .000638039-.0440208-.0105974-.0874002-.0325249-.125576l-7.04918e-08-1.23446e-07c-.476529-.834502-.186334-1.8973.648168-2.37383 .834502-.476529 1.8973-.186334 2.37383.648168 .305333.534703.305333 1.19096-1.40984e-07 1.72566l-1.35864e-08 2.36541e-08c-.0673929.117333-.0269089.267082.0904236.334475 .0381762.0219275.0815556.033163.125576.0325249h2.773"></path>
        <path d="M12 21v-2.773l4.73969e-10 3.27009e-08c-.00196099-.135296.106128-.246564.241424-.248525 .0440208-.000638044.0874002.0105974.125576.0325249l1.05427e-07 6.02026e-08c.834502.476529 1.8973.186334 2.37383-.648168 .476529-.834502.186334-1.8973-.648168-2.37383 -.534703-.305333-1.19096-.305333-1.72566 1.20405e-07l1.85965e-08-1.06814e-08c-.117333.0673929-.267082.0269088-.334475-.0904238 -.0219274-.0381762-.0331629-.0815555-.0325249-.125576v-2.773h-2.773l1.42058e-08 2.05901e-10c-.135296-.00196098-.246564.106128-.248525.241424 -.000638041.0440208.0105974.0874002.0325249.125576l-4.93939e-09-8.6499e-09c.476529.834502.186334 1.8973-.648168 2.37383 -.834502.476529-1.8973.186334-2.37383-.648168 -.305333-.534703-.305333-1.19096-9.87877e-09-1.72566l6.92089e-10-1.20494e-09c.0673929-.117333.0269089-.267082-.0904236-.334475 -.0381762-.0219275-.0815556-.033163-.125576-.0325249h-2.773"></path>
        <rect width="18" height="18" x="3" y="3" rx="2.2279" ry="0"></rect>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})
const ToysPuzzleTwoTone = createIcon({
  displayName: 'ToysPuzzleTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="g"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
        color="twoToneStrokeColor"
      >
        <Box
          as="path"
          fill="twoToneFillColor"
          d="M12 3v2.773l-3.94174e-10-2.71955e-08c.00196099.135296-.106128.246564-.241424.248525 -.0440208.000638043-.0874002-.0105974-.125576-.0325249l1.22727e-07 7.00814e-08c-.834502-.476529-1.8973-.186334-2.37383.648168 -.476529.834502-.186334 1.8973.648168 2.37383 .534703.305333 1.19096.305333 1.72566 1.40163e-07l-3.20824e-08 1.84274e-08c.117332-.067393.267082-.0269091.334475.0904234 .0219275.0381762.033163.0815556.032525.125576v2.773h2.773l-6.41897e-09-9.30367e-11c.135296.00196098.246564-.106128.248525-.241424 .000638039-.0440208-.0105974-.0874002-.0325249-.125576l-7.04918e-08-1.23446e-07c-.476529-.834502-.186334-1.8973.648168-2.37383 .834502-.476529 1.8973-.186334 2.37383.648168 .305333.534703.305333 1.19096-1.40984e-07 1.72566l-1.35864e-08 2.36541e-08c-.0673929.117333-.0269089.267082.0904236.334475 .0381762.0219275.0815556.033163.125576.0325249h2.773"
        ></Box>
        <Box
          as="path"
          fill="twoToneFillColor"
          d="M12 21v-2.773l4.73969e-10 3.27009e-08c-.00196099-.135296.106128-.246564.241424-.248525 .0440208-.000638044.0874002.0105974.125576.0325249l1.05427e-07 6.02026e-08c.834502.476529 1.8973.186334 2.37383-.648168 .476529-.834502.186334-1.8973-.648168-2.37383 -.534703-.305333-1.19096-.305333-1.72566 1.20405e-07l1.85965e-08-1.06814e-08c-.117333.0673929-.267082.0269088-.334475-.0904238 -.0219274-.0381762-.0331629-.0815555-.0325249-.125576v-2.773h-2.773l1.42058e-08 2.05901e-10c-.135296-.00196098-.246564.106128-.248525.241424 -.000638041.0440208.0105974.0874002.0325249.125576l-4.93939e-09-8.6499e-09c.476529.834502.186334 1.8973-.648168 2.37383 -.834502.476529-1.8973.186334-2.37383-.648168 -.305333-.534703-.305333-1.19096-9.87877e-09-1.72566l6.92089e-10-1.20494e-09c.0673929-.117333.0269089-.267082-.0904236-.334475 -.0381762-.0219275-.0815556-.033163-.125576-.0325249h-2.773"
        ></Box>
        <rect width="18" height="18" x="3" y="3" rx="2.2279" ry="0"></rect>
      </Box>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const ToysPuzzle: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={ToysPuzzleTwoTone} {...props} />
  default:
    return <CustomIcon as={ToysPuzzleOutline} {...props} />
  }
}

export default memo(ToysPuzzle)
